import { Injectable, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { RemittanceSummary } from "../../models/remittance-summary.model";
import { BaseService } from "../api-base.service";
import { ReconApiService } from "../recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class RemittanceSummaryService implements OnInit {
  private readonly timeout: number = 30000;
  private readonly basePath: string = "Remittance";

  ngOnInit(): void {}

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async getRemittanceSummary<T>(
    clientId: string,
    checkRefNumber: number
  ): Promise<RemittanceSummary> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/Checks/${checkRefNumber}/StagedRemittanceSummary/`;
    let response = await this.http
      .get(url, { headers: this.apiBase.getHeaders() })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
      });
    return response;
  }

  public async submitRemittanceBatch<T>(
    clientId: string,
    checkRefNumber: number
  ): Promise<boolean> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/Checks/${checkRefNumber}/SubmitBatch/`;
    let response = await this.http
      .post<any>(
        url,
        "", // no body to post
        { headers: this.apiBase.getHeaders() }
      )
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/Checks/${checkRefNumber}/SubmitBatch/`
        );
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/remittance-summary.service.ts